module.exports = __webpack_public_path__ + "static/knittedwhite-cc68cdba85237a4cd46761f92bb7105d.jpeg";